import { useMemo } from "react";

import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";
import useMakeFiltersData from "components/Filters/useMakeFiltersData";

import { INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY } from "./constants";
import { SEARCH_INTENT_RESOURCES_OPERATIONS_SUGGESTIONS } from "./gql";
import useIntentProjectOperationFiltersVariables from "./useFiltersVariables";

const useSearchIntentResourcesOperationsSuggestions = (intentProjectId: string) => {
  const { fullTextSearch, predicates, filterVariablesLoaded } =
    useIntentProjectOperationFiltersVariables();

  const { data, error, previousData, loading } = usePolledQuery(
    SEARCH_INTENT_RESOURCES_OPERATIONS_SUGGESTIONS,
    {
      variables: {
        intentProjectId,
        input: {
          fullTextSearch,
          predicates,
          fields: null,
        },
      },
      skip: !filterVariablesLoaded,
      pollingGroup: PollingIntervalGroups.SingleEntities,
    }
  );

  const cachedSuggestions = useMemo(() => {
    return (
      data?.intentProject?.searchIntentResourcesOperationsSuggestions?.fields ||
      previousData?.intentProject?.searchIntentResourcesOperationsSuggestions?.fields ||
      []
    );
  }, [data, previousData]);

  const filteredCount = useMemo(() => {
    return (
      data?.intentProject?.searchIntentResourcesOperationsSuggestions?.filteredCount ||
      previousData?.intentProject?.searchIntentResourcesOperationsSuggestions?.filteredCount ||
      0
    );
  }, [data, previousData]);

  const { filters, filterOptionsMap } = useMakeFiltersData({
    suggestions: cachedSuggestions,
    dictionary: INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY,
  });

  return {
    filters,
    filterOptionsMap,
    filteredCount,
    loading: loading || !filterVariablesLoaded,
    error,
  };
};

export default useSearchIntentResourcesOperationsSuggestions;
